// @ts-check
import {
  Box,
  SkeletonBox,
  SkeletonText,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
  Text,
} from '~/design-system';
import { Trans } from '@lingui/macro';

/**
 * The props that this component needs.
 * @typedef {object} ValidateImportStepProps
 * @property {Object} props.importData - the import data object
 * @property {Boolean} props.isValid - global validation flag
 * @property {Object[]} props.masterListColumns - the master list columns to this import
 */

/**
 * Renders the page while validation is in progress
 */
export default function ValidationSkeleton({ ...rest }) {
  return (
    <Box
      sx={{
        textAlign: 'center',
        marginTop: 2,
        padding: '0px 15% 30px 15%',
      }}
      {...rest}
    >
      <Table
        sx={{
          border: '1px solid',
          borderColor: 'brand.lightGray',
          width: '100%',
        }}
        {...rest}
      >
        <TableHead>
          <TableRow>
            <TableHeader
              sx={{
                width: 90,
                backgroundColor: 'brand.lightGray',
                textAlign: 'center',
              }}
            >
              <Text variant="smallest">
                <Trans>Valid</Trans>
              </Text>
            </TableHeader>
            <TableHeader
              sx={{ backgroundColor: 'brand.lightGray', width: 250 }}
            >
              <Text variant="smallest">
                <Trans>Bottlebooks field name</Trans>
              </Text>
            </TableHeader>
            <TableHeader
              sx={{ backgroundColor: 'brand.lightGray', width: 250 }}
            >
              <Text variant="smallest">
                <Trans>Import column name</Trans>
              </Text>
            </TableHeader>
            <TableHeader
              sx={{ backgroundColor: 'brand.lightGray', width: 250 }}
            >
              <Text variant="smallest">
                <Trans>Errors</Trans>
              </Text>
            </TableHeader>
          </TableRow>
        </TableHead>
        <TableBody>
          <SkeletonRow />
          <SkeletonRow />
          <SkeletonRow />
          <SkeletonRow />
          <SkeletonRow />
        </TableBody>
      </Table>
    </Box>
  );
}

function SkeletonRow() {
  return (
    <TableRow>
      <TableCell sx={{ width: 90, height: '65px', textAlign: 'center' }}>
        <SkeletonBox height={20} width={20} sx={{ display: 'inline-block' }} />
      </TableCell>
      <TableCell
        sx={{
          height: '65px',
          position: 'relative',
          textAlign: 'left',
        }}
      >
        <SkeletonText />
      </TableCell>
      <TableCell sx={{ height: '65px', textAlign: 'left' }}>
        <SkeletonText />
      </TableCell>
      <TableCell
        sx={{
          height: '65px',
          position: 'relative',
          textAlign: 'left',
        }}
      >
        <SkeletonText />
      </TableCell>
    </TableRow>
  );
}
